import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { DynamicFieldProps } from './types';


interface Props {
  options?: object
}
const SelectList = (props: DynamicFieldProps & Props) => {
  const { field, options, mandatory } = props;
  const optionsId = field.TypeDetail;
  const [value, setValue] = React.useState('');

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value, optionsId, options]);

  return (
    <Grid item md={props.width} xs={12}>
      <FormControl
        aria-readonly={field.ReadOnly}
        disabled={field.ReadOnly}
        style={props.style}
        error={field.Error}
        required={mandatory}
      >
        <InputLabel id={field.Name}>{field.Label}</InputLabel>
        <Select
          inputRef={props.reference}
          labelId={field.Name}
          id={field.Name}
          value={value}
          onChange={e => {
            const val = e.target.value as string;
            setValue(val);
            props.formValueChanged && props.formValueChanged(field.Name, val);
          }}
        >
          {options && options[optionsId] && Object.entries(options[optionsId]).map(e => (
            <MenuItem key={e[0]} value={e[0] as string}>{e[1] as string}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default SelectList;
